module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAgCAYAAABU1PscAAAAwElEQVRYR2M8u4lnpazYDzWGIQiu3OFZz/jqOMt+Ad4/DkPQ/Qx3HnFOHPXAQMbcaAwMZOiD7B6NgdEYoDAERpMQhQFIsfbRGKA4CCk0YDQGKAxAirUPjxhgCZyx/w8L55BsTnP+fD2RcdQDFKdk8g0YjQHyw446OkdjgDrhSL4pwyMGDhhY7+dhYByS9cBjhr8TGUc9QH4SpljnaAxQHIQUGjAaAxQGIMXawTGw3MB6nSQDgyLFpg2AAdcY/mwHAD6isu+OYKzcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/c044.png
// module id = l4Pm
// module chunks = 18